import { clsxMerge } from '@/app/lib/utils/styles';
import type { CSSProperties } from 'react';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import { nord } from 'react-syntax-highlighter/dist/esm/styles/prism';
import jsx from 'react-syntax-highlighter/dist/esm/languages/prism/jsx';
import { menlo } from '@/app/ui/fonts';
SyntaxHighlighter.registerLanguage('jsx', jsx);

export interface HighlighterProps {
  content: string;
  language: 'bash' | 'jsx' | 'html';
  showLineNumbers?: boolean;
  codeClassName?: string;
  customStyle?: CSSProperties;
}

export default function Highlighter({ content, language, showLineNumbers = true, codeClassName, customStyle }: HighlighterProps) {
  return (
    <div className='relative'>
      <SyntaxHighlighter
        language={language}
        style={nord}
        customStyle={{ minHeight: 60, borderRadius: '1rem', margin: 0, ...customStyle }}
        codeTagProps={{ className: clsxMerge(`${menlo.className} leading-normal font-normal text-sm`, codeClassName) }}
        showLineNumbers={showLineNumbers}
        tabIndex={0}
      >
        {content}
      </SyntaxHighlighter>
    </div>
  );
}
